/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1TutoraiUsageQueryResponse,
  GetApiV1TutoraiUsageQueryParams,
  GetApiV1TutoraiUsage401,
  GetApiV1TutoraiUsage500,
} from "../../types/tutorAIUsageController/GetApiV1TutoraiUsage.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1TutoraiUsage } from "../../clients/tutorAIUsageController/getApiV1TutoraiUsage.ts";

export const getApiV1TutoraiUsageQueryKey = (
  params?: GetApiV1TutoraiUsageQueryParams,
) => [{ url: "/api/v1/tutorai/usage" }, ...(params ? [params] : [])] as const;

export type GetApiV1TutoraiUsageQueryKey = ReturnType<
  typeof getApiV1TutoraiUsageQueryKey
>;

export function getApiV1TutoraiUsageQueryOptions(
  params?: GetApiV1TutoraiUsageQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1TutoraiUsageQueryKey(params);
  return queryOptions<
    GetApiV1TutoraiUsageQueryResponse,
    ResponseErrorConfig<GetApiV1TutoraiUsage401 | GetApiV1TutoraiUsage500>,
    GetApiV1TutoraiUsageQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1TutoraiUsage(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna métricas detalhadas de consumo de tokens para o aluno. Período padrão: últimos 30 dias. Os limites (`dailyLimit`, `monthlyLimit`, `weeklyLimit`) sempre refletem o dia/semana/mês correntes, independente do filtro de período. **(Requer Authorization para autenticação)**
 * @summary Relatório de uso de tokens por aluno (Requer Authorization para autenticação)
 * {@link /api/v1/tutorai/usage}
 */
export function useGetApiV1TutoraiUsage<
  TData = GetApiV1TutoraiUsageQueryResponse,
  TQueryData = GetApiV1TutoraiUsageQueryResponse,
  TQueryKey extends QueryKey = GetApiV1TutoraiUsageQueryKey,
>(
  params?: GetApiV1TutoraiUsageQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1TutoraiUsageQueryResponse,
        ResponseErrorConfig<GetApiV1TutoraiUsage401 | GetApiV1TutoraiUsage500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1TutoraiUsageQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1TutoraiUsageQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiV1TutoraiUsage401 | GetApiV1TutoraiUsage500>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
